import { useState } from 'react'
import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import Textarea from '../../../../Core/Fields/Floating/Textarea';
import ActivityCard from '../../../../Core/Activity/ActivityCard';
import Checkbox from "../../../../Core/Fields/Floating/Checkbox";
const Tab1 = ({ customertypelist, setCustoemrtype, customertype, setCustoemrName,
    customername, setMobile, mobile,
    customergrplist, setcustomerGrp, customergrp,
    terilist, terittory, setTerittory,
    setlead, lead, leadlist,
    setAccount, account, accountlist,
    isGroup, setIsGroup,
    setCurrency, currency, currencylist,
    price, setPrice, pricelist,
    setBankAccount, bankAccount, banklist,
    setMarket, market, marketList,
    industry, setIndustry, industrylist,
    website, setWebsite,
    customerDetails, setCustomerDetails
}) => {

 
    const status = 'no'
    return (

        <div>
      <div className="px-2 py-3" style={{ background: 'white' }}>
        <div style={{ display: 'flex' }} >
          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Details</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                     <Input
                                id="CustomerName"
                                label="Customer Name"
                                style={{ height: "30px" }}
                                value={customername}
                                readOnly
                                onChange={(e) => setCustoemrName(e.target.value)}
                            />

                </div>
                <div style={{ flex: 1 }}>
                    <Input
                                id="CustomerName"
                                label="Customer Name"
                                style={{ height: "30px" }}
                                value={customertype}
                                readOnly
                            />


                </div>
                <div style={{ flex: 1 }}>
                  <Input
                                id="Mobile"
                                label="Mobile"
                                value={mobile}
                                readOnly
                                style={{ height: "30px" }}
                            />
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                    <Input

                                label="Customer Group"
                                value={customergrp}
                                readOnly
                                style={{ height: "30px" }}
                            />
                </div>


                <div style={{ flex: 1 }}>
                 <Input

                            label="Territory"
                            value={terittory}
                            readOnly
                            onChange={(e) => setMobile(e.target.value)}
                            style={{ height: "30px" }}
                        />

                </div>
                <div style={{ flex: 1 }}>
                  <Input
                            label="From Lead"
                            value={lead}
                            readOnly
                            onChange={(e) => setMobile(e.target.value)}
                            style={{ height: "30px" }}
                        />
                </div>
              </div>
 <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <Input
                            label="Account Manager"
                            value={account}
                            readOnly
                            onChange={(e) => setMobile(e.target.value)}
                            style={{ height: "30px" }}
                        />
                </div>


                <div style={{ flex: 1 }}>
                 

                </div>
                <div style={{ flex: 1 }}>
                  
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Defaults</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>


                <div style={{ flex: 1 }}>
                 <Input
                                label="Billing Currency"
                                value={currency}
                                readOnly

                                style={{ height: "30px" }}
                            />

                </div>
                <div style={{ flex: 1 }}>
                 <Input
                                label="Default Company Bank Account"
                                value={bankAccount}
                                readOnly

                                style={{ height: "30px" }}
                            />



                </div>
                <div style={{ flex: 1 }}>
                  <Input
                                label="Default Price List"
                                value={price}
                                readOnly

                                style={{ height: "30px" }}
                            />
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>

                <div style={{ flex: 1 }}>

                  <Input
                                label="Industry Type"
                                value={industry}
                                readOnly

                                style={{ height: "30px" }}
                            />
                  

                </div>
<div style={{ flex: 1 }}>
                  <Input
                                label="Market Segment"
                                value={market}
                                readOnly

                                style={{ height: "30px" }}
                            />
                </div>
<div style={{ flex: 1 }}>
                 <Input
                                id="CustomerName"
                                label="Website"
                                readOnly
                                style={{ height: "30px" }}
                                value={website}
                                onChange={(e) => setWebsite(e.target.value)}
                            />
                </div>

              </div>

              <div style={{ display: 'flex', gap: '15px' }}>
               <div style={{ flex: 1 }}>
  <label style={{ height: '19px' }}></label>
  <Checkbox
    id="IsInternalCustomer"
    label="Is Internal Customer"
    value={isGroup===1 || false}   
    disabled={true}
  />
 

</div>

                
                <div style={{ flex: 1 }}>
                   <Textarea
                            id="BrandDescription"
                            label="Description"
                            readOnly={status}
                            value={customerDetails}
                        />
                    <p
                    style={{
                      paddingLeft: "4px",
                      paddingRight: "14px",
                      fontWeight: 400,
                      fontSize: "9px",
                      letterSpacing: "0",
                      color: "#2C2B31",
                      lineHeight: '2',
                      fontFamily: "Roboto, sans-serif",
                      marginTop: '0px'
                    }}
                  >
                    Additional information regarding the customer.
                  </p>

                </div>
                 <div style={{ flex: 1 }}>
                 
                </div>
              </div>

            </div>
          </div>
        </div>
           <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

          <div className="col-md-12">
            <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
             <ActivityCard doctype="Customer" docname={customername} />
            </div>
          </div>
        </div>
      </div>

    </div>
    )
}

export default Tab1